import { render, staticRenderFns } from "./btns_cart.vue?vue&type=template&id=cd0de04c"
import script from "./btns_cart.vue?vue&type=script&lang=js"
export * from "./btns_cart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports